import { EnvironmentProviders, Provider } from '@angular/core';
import { provideReportingDashboard as provideReportingDashboardLib } from '@flyfreely/user-reporting-dashboard';

export function provideReportingDashboard(): Array<Provider | EnvironmentProviders> {
  // Runs while the NgModule providers array is being built (before DI exists),
  // so the reporting API URL is read straight off window.appConfig, matching
  // the pattern used in apps/user/src/app/app.module.ts. Defaults to the
  // /dynamicReportsApi proxy path (dev server / nginx route to the backend).
  // @ts-ignore - declared in src/global.d.ts
  const appConfig = (window as any).appConfig || {};
  return [
    provideReportingDashboardLib({
      apiUrl: appConfig.REPORTING_API_URL || '/dynamicReportsApi'
    })
  ];
}
